

import * as React from 'react';
import { Flex } from '@flightstats/airframe-react';

import { CiriumModal } from '../../../components/cirium/CiriumModal';
import { NoHrefLink } from '../../../components/cirium/NoHrefLink';

export type ChangePasswordModalProps = {
  showModal: boolean,
  closeModal: () => void,
  title: string,
  children: React.ReactNode,
};

export const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  showModal,
  closeModal,
  title,
  children,
}) => (
  <CiriumModal showModal={showModal} closeModal={closeModal} title={title}>
    {children}
    <Flex className='change-password-modal-flex'>
      <NoHrefLink mt="50px" textAlign="center" onClick={closeModal}>
        Cancel
      </NoHrefLink>
    </Flex>
  </CiriumModal>
);
